var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$store.state.webNavigator == "pc"
      ? _c("div", { staticClass: "homeShop" }, [
          _c("div", { staticClass: "home-shop marginAuto max1720" }, [
            _vm._m(0),
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "swiper-container banner4 home-team-bar home-rol"
                },
                [
                  _c(
                    "div",
                    { staticClass: "swiper-wrapper" },
                    _vm._l(_vm.rolllist3, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "swiper-slide" },
                        [
                          _c("img", {
                            staticClass: "home-team-img",
                            attrs: {
                              src: item,
                              alt: "3大保障·脂玫乐健康瘦身值得您托付",
                              title: ""
                            }
                          })
                        ]
                      )
                    }),
                    0
                  ),
                  _c("div", { staticClass: "swiper-button-prev" }),
                  _c("div", { staticClass: "swiper-button-next" }),
                  _c("div", { staticClass: "swiper-pagination" })
                ]
              )
            ])
          ])
        ])
      : _c("div", { staticClass: "homeShop" }, [
          _c("div", { staticClass: "home-shop marginAuto" }, [
            _vm._m(1),
            _c("div", [
              _c(
                "div",
                {
                  staticClass: "swiper-container banner4 home-team-bar home-rol"
                },
                [
                  _c(
                    "div",
                    { staticClass: "swiper-wrapper" },
                    _vm._l(_vm.rolllist3Phone, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "swiper-slide" },
                        [
                          _c("img", {
                            staticClass: "home-team-img",
                            attrs: {
                              src: _vm.httptype(item),
                              alt: "3大保障·脂玫乐健康瘦身值得您托付",
                              title: ""
                            }
                          })
                        ]
                      )
                    }),
                    0
                  )
                ]
              )
            ])
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "p",
        {
          staticClass: "part-title list-tlt displayIB",
          staticStyle: { width: "100%", color: "#ffffff" }
        },
        [_vm._v("\n          3大保障·脂玫乐健康瘦身值得您托付\n        ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "PhoneHome-title" }, [
      _vm._v("3大保障 "),
      _c("span", { staticClass: "col00CDA2" }, [_vm._v("-")]),
      _c("br"),
      _vm._v(" 脂玫乐健康瘦身值得您托付 ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42561103", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42561103","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/hometest/comPonents/homeShop/homeShop.vue
// module id = 977
// module chunks = 1